import { Grid } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import { useState } from "react"
import { LoadingButton } from "@mui/lab"
import { ClientsService } from "../../../../../../../services/clients"
import { InputComponent } from "../../../../../../../components/input"
import { useForm } from "react-hook-form"
import { CellphoneMaskCustom } from "../../../../../../../components/mask"
import { Utils, Validators } from "../../../../../../../utils"

interface Props {
    open: boolean,
    onClose: (sended?: boolean) => void
}

export const ModalChangeNumber = ({
    onClose,
    open
}: Props) => {
    const [loading, setLoading] = useState(false)
    const {
        register,
        watch,
        formState: { errors },
        setValue,
        handleSubmit
    } = useForm<{ phone: string }>()

    const updateNumber = ({ phone}: { phone: string }) => {
        setLoading(true)
        ClientsService.updatePhone(Utils.onlyDigits(phone))
            .then(() => {
                onClose(true)
            })
            .finally(() => setLoading(false))
    }

    return (
        <ModalComponent
            open={open}
            onClose={() => onClose()}
            title="Mudar meu número de telefone"
            description="Informe abaixo o número de telefone correto para receber o SMS de confirmação"
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >
                <InputComponent
                    label="Número"
                    value={watch("phone") || ""}
                    onChangeValue={(value) => setValue("phone", value, { shouldValidate: true })}
                    error={!!errors.phone}
                    helperText={errors.phone?.message}
                    disabled={loading}
                    mask={CellphoneMaskCustom}
                    placeholder="(XX) X XXXX-XXXX"
                    {...register("phone", {
                        required: {
                            value: true,
                            message: "Informe seu Número"
                        },
                        validate: (value) => {
                            if (!Validators.validateWhatsAppNumber(value)) {
                                return "Número inválido!";
                            }
                        },
                    })}
                />

                <LoadingButton variant="contained" loading={loading} onClick={handleSubmit(updateNumber)}>Continuar</LoadingButton>
            </Grid>
        </ModalComponent>
    )
}